import axios from 'axios';
import React, {useState, useEffect, useMemo, Fragment, useRef} from 'react';

import { FormControl, InputLabel, Input, FormHelperText, Alert } from '@mui/material';
import WebService from '@util/webService'
import {encodeParams, getAction} from '@util/helper'
// redux
import { useSelector, useDispatch } from 'react-redux';
// MUI Table
import CssBaseline from '@mui/material/CssBaseline'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
// react-table
import { useTable, useExpanded } from 'react-table'
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Checkbox, FormGroup, FormControlLabel, Typography, Snackbar, TablePagination, TextField,withStyles,InputBase } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import '@scss/App.scss'
import Button from '@mui/material/Button'
import FlatButton from '@components/FlatButton';
import useSnackbar from '@hooks/useSnackbar';
import MyTableHead from '@components/MyTableHead';
import useIndicator from '@hooks/useIndicator';
import Indicator from '@components/Indicator';
import MyDialog from '@components/MyDialog';
import useForm from '@hooks/useForm';
import Box from '@mui/material/Box';

import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import {useParams} from "react-router-dom";
import ProfileManagerPartApply from "@pages/profile/profile-manager.part.apply";

const ProfileManagerPage = () => {
  const defUrl = '/agmt'
  // redux
  const codeGroups = useSelector(state => state.codeGroupReducer)
  const codes = useSelector(state => state.codeReducer)
  const account = useSelector(state => state.accountReducer)
  const navigate = useNavigate()
  const {more} = useParams()
  const dateFormat = 'YYYY-MM-DD HH:mm:ss'

  const fields = [
    {field: 'id', placeholder: 'ID',    type:'text', value:-1, visible: more && (more === 'more'), disabled: false, canSrch:false, selList:[]},
    {field: 'companyId', placeholder: '소속업체',    type:'text', value:'', visible: false, disabled: false, canSrch:false,selList:[]},
    {field: 'companyName', placeholder: '소속업체',    type:'text', value:'', visible: true, disabled: false, canSrch:false,selList:[]},
    {field: 'rltnCode', placeholder: '관계', type:'text', value:'', visible: false, disabled: false, canSrch:false,selList:[]},
    {field: 'rltnName', placeholder: '관계', type:'text', value:'', visible: true, disabled: false, canSrch:false,selList:[]},
    {field: 'statCode', placeholder: '상태', type:'select', value:'', visible: false, disabled: false, canSrch:false,selList:['Y', 'N']},
    {field: 'statName', placeholder: '상태', type:'select', value:'', visible: true, disabled: false, canSrch:false,selList:['Y', 'N']},
  ]

  const visibleColumns = fields.filter(col => col.visible)
  const defRecord = {}
  fields.forEach(d => {
    defRecord[d.field] = d.value
  })
  defRecord.schoolList = []
  const recordRef = useRef(defRecord)
  const defTerms = {}
  fields.filter(col => col.canSrch).map(d => d.field).forEach(d => defTerms[d] = '')
  const [dataList, set_dataList] = useState(null)
  const [fieldList, set_fieldList] = useState([])
  const [companies, set_companies] = useState([])
  const [schoolList, set_schoolList] = useState([])
  const [skipPageReset, setSkipPageReset] = React.useState(false)
  const [openSnackbar, renderSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const dgHandler = useState(false)
  const [selIdx, set_selIdx] = useState(-1)
  const [pageNum, set_pageNum] = useState(0)
  const [pageSize, set_pageSize] = useState(10)
  const [totalCount, set_totalCount] = useState(0)
  const [pageInfo, set_pageInfo] = useState({pageNum:0, pageSize: 10})
  const [terms, _set_terms] = useState(defTerms)
  const termsRef = useRef(terms)
  const applyHandler = useState(false)

  const set_terms = data => {
    termsRef.current = data
    _set_terms(data)
  }

  useEffect(() => {
    onLoad()
  }, [pageInfo])

  const onLoad = async() => {
    openIndicator()

    let url = ''
    let resp = {}
    
    //
    url = '/company'
    resp = await WebService.get(url)

    if(resp.repCode === 'reject') {
      navigate('/login')
      return
    }

    let companyList = []
    if(resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const records = JSON.parse(repMessage.records)
      companyList = records
      set_companies(companyList)
    }

    //
    url = `/user/rltn`
    resp = await WebService.get(url, {userId: account.user.id})
    
    if(resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const companyRltnList = JSON.parse(repMessage.companyRltnList)
      companyRltnList.forEach(d => {
        d.companyName = companyList.find(r => r.id === d.companyId).name
        d.rltnName = codes.filter(r => r.codeGroupId==='SA14').find(r => r.code === d.rltnCode).name
        d.statName = codes.filter(r => r.codeGroupId==='SA18').find(r => r.code === d.statCode).name
      })
      set_dataList(companyRltnList)
    }

    const newFields = [...fields]
    set_fieldList(newFields)
    closeIndicator()
  }


  const onDelete = async(id) => {
    const url = defUrl
    const resp = await WebService.delete(url, {id: id})
    if(resp.repCode === 'ack') {
      onLoad()
      openSnackbar('삭제되었습니다.')
    }
    else {
      openSnackbar(resp.repMessage)
    }
    
  }
  
  const onCreate = () => {
    const now = moment().format(dateFormat)
    const newRecord = {...defRecord, regTime: now, uptTime: now, schoolRltnList:[]}
    // set_record(newRecord)
    dgHandler[1](true)
  }

  const onSearch = () => {
    onLoad()
  }

  const onClear = () => {
    const obj = {}
    Object.keys(terms).forEach(k => {
      obj[k] = ''
    })
    set_terms(obj)
  }

  if(dataList != null) {
    return (
      <div >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}>
          <div style={{ paddingRight: 10 }}>
            <h1>소속 업체 목록</h1>
          </div>
        </div>
        <div style={{display:'flex', flexDirection:'row'}}>
          <Button variant='outlined' color='primary' size='small' onClick={() => {applyHandler[1](true)}}>위탁사 매니저 등록 신청</Button>
        </div>
        
        <div style={{paddingTop:20}}>
          <MUITable>
            <MyTableHead >
              <TableRow>
                {
                  fieldList.map((col, index) => {
                    if(col.visible) {
                      return(
                        <TableCell key={index} size='small' key={col.field}>
                          {col.placeholder}
                          {col.canSrch? 
                            ( 
                              <Fragment>
                                  <TextField label="" variant="outlined" size='small' inputProps={{style: {fontSize: '0.875em', padding:5, backgroundColor:'#fff'}}} 
                                    value={terms[col.field]}
                                    onChange={(e) => {
                                      const newTerms = {...terms}
                                      newTerms[col.field] = e.target.value
                                      set_terms(newTerms)
                                    }}
                                  />
                              </Fragment>
                            )
                            : (
                              <Fragment>
                              </Fragment>
                            )
                          }
                        </TableCell>
                      )
                    }
                  })
                }
                <TableCell size='small'>
                </TableCell>
              </TableRow>
            </MyTableHead>
            <TableBody>
              {
                dataList.map((row, index) => {
                  return(
                    <Fragment key={index}>
                      <TableRow onClick={()=> {
                        recordRef.current = row
                      }}>
                          {
                            fieldList.map((col, index2) => {
                              if(col.visible) {
                                return(
                                  <TableCell key={index2} size='small'>
                                    {row[col.field]}
                                  </TableCell>
                                )
                              }
                            })
                          }
                          <TableCell size='small'>
                            {/*
                            <FlatButton variant='outlined' size='small'  style={{marginRight:5}} onClick={() => onDetail(row.id)}>보기</FlatButton>
                            <FlatButton variant='outlined'  color='error' size='small' onClick={() => onDelete(row.id)}>삭제</FlatButton>
                            */}
                            
                          </TableCell>
                        </TableRow>
                      </Fragment>
                  )
                })
              }
            </TableBody>
            <TableFooter>
            <TableRow>
            </TableRow>
          </TableFooter>
          </MUITable>
           {applyHandler[0] ? (<ProfileManagerPartApply record={recordRef.current} relationList={dataList} dialogHandler={applyHandler} callback={onLoad} />) : null }
           {renderSnackbar()}
           {renderIndicator()}
          </div>
      </div>
    );
  }
  
}

export default ProfileManagerPage
